import { useIsPending } from '~/utils/misc.ts';

import { StatusButton, type StatusButtonProps } from '../ui/status-button.tsx';

type Props = Omit<StatusButtonProps, 'status'>;

export function SubmitButton({ children, ...rest }: Props) {
  const isSubmitting = useIsPending();
  return (
    <StatusButton type="submit" color="primary" {...rest} status={isSubmitting ? 'pending' : 'idle'}>
      {children}
    </StatusButton>
  );
}
